import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const MODULE_1_BOOK = 'https://cdn.magicpatterns.com/uploads/8Y3BJzyTdc8jBdy5y89EYZ/Diseno_sin_titulo_(1).png';
const MODULE_2_BOOK = 'https://cdn.magicpatterns.com/uploads/wvULnSs8UkTgXZiDnTMtrf/Diseno_sin_titulo_(2).png';
const MODULE_3_BOOK = 'https://cdn.magicpatterns.com/uploads/2XZW25dv7LYPcyvjL2JnXJ/Diseno_sin_titulo_(3).png';
const MODULE_4_BOOK = 'https://cdn.magicpatterns.com/uploads/tWcE9T94tLeDtk4FvMhDsm/Diseno_sin_titulo_(4).png';
export function CurriculumSection() {
  return <section className="py-16 md:py-20 bg-[#4F7F53] w-full pt-[10px] pb-[10px] space-y-[12px]" data-id="element-87">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-white font-bold font-sans text-2xl md:text-3xl text-center mb-12 pt-[15px] pb-[15px]" data-id="element-89">
          En este E-BOOK encontrarás...
        </motion.h2>

        <div className="flex gap-16 flex-col items-start justify-start" data-id="element-90">
          {/* Module 1: Image Left, Card Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-91">
            <img src={MODULE_1_BOOK} alt="Fundamentos del Bubble Tea" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-92" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-93">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-94">
                Esenciales Bubble Tea
              </h3>
              <ul className="space-y-3" data-id="element-95">
                <li className="flex items-start gap-3" data-id="element-96">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-97">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-98" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-99">
                    La historia secreta detrás de esta bebida que conquistó el
                    mundo.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-100">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-101">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-102" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-103">
                    Ingredientes esenciales y herramientas que necesitas para
                    empezar.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-104">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-105">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-106" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-107">
                    Trucos y utensilios avanzados que elevarán tu nivel.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Module 2: Card Left, Image Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12" data-id="element-108">
            <img src={MODULE_2_BOOK} alt="La Base Perfecta" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-109" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-110">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-111">
                La Mezcla Perfecta
              </h3>
              <ul className="space-y-3" data-id="element-112">
                <li className="flex items-start gap-3" data-id="element-113">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-114">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-115" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-116">
                    Cómo preparar la infusión de té perfecta (verde, negro,
                    oolong).
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-117">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-118">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-119" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-120">
                    Errores comunes al hacer té y cómo evitarlos.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-121">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-122">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-123" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-124">
                    Las mejores leches y alternativas vegetales para un sabor
                    increíble.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Module 3: Image Left, Card Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-125">
            <img src={MODULE_3_BOOK} alt="Perlas de Tapioca" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-126" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-127">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-128">
                Perlas de Tapioca
              </h3>
              <ul className="space-y-3" data-id="element-129">
                <li className="flex items-start gap-3" data-id="element-130">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-131">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-132" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-133">
                    <strong data-id="element-134">¡Adiós perlas duras o sin sabor!</strong> Aprende a
                    hacerlas como un pro.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-135">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-136">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-137" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-138">
                    Perlas de matcha, chocolate, café, fresa, caramelo y más.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-139">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-140">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-141" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-142">
                    Cómo darle un toque único con sustitutos innovadores.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Module 4: Card Left, Image Right */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12" data-id="element-143">
            <img src={MODULE_4_BOOK} alt="Sabores Clasicos Reinventados" className="w-full md:w-[45%] h-auto drop-shadow-2xl object-contain" data-id="element-144" />
            <div className="w-full md:w-[55%] bg-white rounded-2xl p-8 shadow-lg" data-id="element-145">
              <h3 className="font-bold text-xl md:text-2xl text-[#3E2723] font-sans mb-4" data-id="element-146">
                Gustos Clasicos Reinventados
              </h3>
              <ul className="space-y-3" data-id="element-147">
                <li className="flex items-start gap-3" data-id="element-148">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-149">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-150" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-151">
                    Recetas tradicionales con un giro inesperado.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-152">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-153">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-154" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-155">
                    <strong data-id="element-156">¿Bubble Tea de tamarindo y chile?</strong> Sí, y
                    muchos más sabores exóticos.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-157">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-158">
                    <CheckIcon className="w-3 h-3 text-white" data-id="element-159" />
                  </div>
                  <span className="text-[#3E2723] text-sm md:text-base font-sans leading-relaxed" data-id="element-160">
                    Combos irresistibles con lavanda, jazmín, lichi y más.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}